module.exports = __webpack_public_path__ + "img/Bundy.e414480f.png";